import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import snack from '@/helpers/snack'

export default {
  GET_GOODS: ({ commit, state, getters }, payload) => {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoods', data.items)
          commit('setGoodFilters', data.filters)
          resolve(data.count)
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.notFoundMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  GET_GOOD: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.one.replace('$1', payload.id)}`,
        {
          params: { with: 'goodGroup;goodBarcodes;images' },
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGood', data)
          commit('setTitle', data.title)
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.notFoundMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  UPDATE_GOOD: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.one.replace('$1', state.good.id)}`,
        {
          title: state.good.title,
          good_type_id: state.good.good_type_id,
          good_brand_id: state.good.good_brand_id,
          good_line_id: state.good.good_line_id,
          article: state.good.article,
          good_group_id: state.good.good_group_id,
          max_use: state.good.max_use,
          min_weight: state.good.min_weight,
          good_barcodes: state.good.good_barcodes,
          company_id: state.good.company_id,
        },
        true,
      )
        .then(response => {
          commit('changeGood', { key: state.good.id, value: state.good })
          commit('setTitle', state.good.title)
          commit('setGoodErrors', null)
          snack.add(Vue.config.localization.ru.refreshedMessage, 'primary')
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.refreshedErrorMessage)
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  async UPDATE_GOOD_FIELDS_BY_ID({ commit, state }, payload) {
    try {
      const response = await request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.one.replace('$1', payload.id)}`,
        payload.fields,
        true,
      )
      if (response.data.result === 'success') {
        snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        if (_.isFunction(payload.onSuccess)) {
          payload.onSuccess()
        }
      }
    } catch (error) {
      console.info(error)
      snack.add(Vue.config.localization.ru.errors.savingGoodError)
    }
  },
  CREATE_GOOD: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.all}`,
        {
          title: {
            ru: state.good.title,
          },
          good_type_id: state.good.good_type_id,
          good_brand_id: state.good.good_brand_id,
          good_line_id: state.good.good_line_id,
          good_group_id: state.good.good_group_id,
          // TODO: Set good country
          country_id: 1,
          good_barcodes: state.good.good_barcodes,
          article: state.good.article,
          max_use: state.good.max_use,
          min_weight: state.good.min_weight,
          company_id: state.good.company_id,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('setGoodField', { key: 'id', value: data.id })
          commit('setTitle', state.good.title)
          commit('unshiftGoods', { ...state.good })
          router.push({ path: Vue.config.modules.crm.route.goods.one.replace('$good_id', data.id) })
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.savedErrorMessage)
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },
  DELETE_GOOD: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goods.one.replace('$1', state.good.id)}`,
        {},
        true,
      )
        .then(response => {
          commit('deleteGood', state.good.id)
          const goodsLength = state.goods.length

          if (goodsLength !== 0) {
            commit('setGood', state.goods[0])
            commit('setGoodField', { key: 'id', value: state.goods[0].id })
            commit('setTitle', state.goods[0].title)
            commit('setGoodErrors', null)
            router.push({ path: Vue.config.modules.crm.route.goods.one.replace('$good_id', 1) })
          } else {
            router.push({ path: Vue.config.modules.crm.route.goods.all })
          }
          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.deleteErrorMessage)
          reject()
        })
        .finally(() => {
          commit('setLoad', false)
        })
    })
  },

  async GET_GOODS_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_GOOD_BRANDS', { params: {} }),
      dispatch('GET_GOOD_GROUPS', { params: {} }),
      dispatch('GET_GOODS', payload),
    ])
    commit('setLoad', false)
  },

  async GET_GOOD_WITH_GOODS({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_COMPANIES', { params: {} }),
      dispatch('GET_GOOD_BRANDS', { params: {} }),
      dispatch('GET_GOOD_LINES', { params: {} }),
      dispatch('GET_GOOD_TYPES', { params: {} }),
      dispatch('GET_GOOD_GROUPS', { params: {} }),
      dispatch('GET_GOODS', { params: payload.params }),
      dispatch('GET_GOOD', payload),
    ])
    commit('setLoad', false)
  },

  async GET_NEW_GOOD_DATA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_COMPANIES', { params: {} }),
      dispatch('GET_GOOD_BRANDS', { params: {} }),
      dispatch('GET_GOOD_LINES', { params: {} }),
      dispatch('GET_GOOD_TYPES', { params: {} }),
      dispatch('GET_GOOD_GROUPS', { params: {} }),
      dispatch('GET_GOODS', { params: payload.params }),
    ])
    commit('setLoad', false)
  },
}
